import script from "./HandCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HandCard.vue?vue&type=script&setup=true&lang=js"

import "./HandCard.vue?vue&type=style&index=0&id=941dc1b8&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-941dc1b8"]])

export default __exports__